module.exports = __webpack_public_path__ + "img/weixin.fa70d854.png";